/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-get */
import Component from '@ember/component';
import { computed } from '@ember/object';
import PaymentMethod from '@linc-technologies/linced-common/enums/payment-method';
import { tagName } from '@ember-decorators/component';

@tagName('')
export default class ChequeDetails extends Component {
  PaymentMethod = PaymentMethod;
  transaction = null;
  detailsOpen = false;

  @computed('transaction.{method,sourceTransaction.method}')
  get chequeTransaction() {
    switch (this.get('transaction.method')) {
      case PaymentMethod.CHEQUE:
      case PaymentMethod.MONEY_ORDER:
        // This is a base transaction, with a method we want.
        return this.transaction;
    }
    switch (this.get('transaction.sourceTransaction.method')) {
      case PaymentMethod.CHEQUE:
      case PaymentMethod.MONEY_ORDER:
        // This is a child transaction of a transaction we want.
        return this.get('transaction.sourceTransaction');
    }
    return null;
  }
}
